export default class HttpClient<T>{
  private baseURL: string;
  private headers: any;

  constructor(baseURL?: string, headers?: any) {
    this.baseURL = rest_var.rest_url || baseURL;
    // if (!rest_var.is_load) {
    //   location.reload();
    // }
    this.headers = headers || {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    };
  }


  private async fetchJSON<T>(endpoint: String, options?: IHttpOptions): Promise<T> {

    return new Promise<T>((resolve, reject) => {
      fetch(this.baseURL + endpoint, {
        ...options,
        headers: this.headers
      })
        .then(response => {
          if (response.ok) {
            return response.json();
          }
          reject(response);
          throw new Error(response.statusText);
        })
        .then(json => {
          resolve(json);
        })
        .catch(error => {
          console.log(error.status, error.statusText);
          // reject({});
        }); //TODO: write to handle error
    });
  }

  public setHeader(key: string, value: string) {
    this.headers[key] = value;
    return this;
  }

  public getHeader(key: string) {
    return this.headers[key];
  }

  public setBasicAuth(username: string, password: string) {
    this.headers.Authorization = `Basic ${btoa(`${username}:${password}`)}`;
    return this;
  }

  public setBearerAuth(token: string) {
    this.headers.Authorization = `Bearer ${token}`;
    return this;
  }

  public get<T>(endpoint: string, options?: IHttpOptions): Promise<T> {
    console.log(endpoint);

    return this.fetchJSON<T>(endpoint, {
      ...options,
      method: HttpMethods.GET
    });

  }

  public post<T>(endpoint: string, body: any, options?: IHttpOptions): Promise<T> {
    return this.fetchJSON<T>(endpoint, {
      ...options,
      body: body ? this.buildBody(body) : undefined,
      method: HttpMethods.POST
    });
  }

  public put<T>(endpoint: string, body: any, options?: IHttpOptions): Promise<T> {
    return this.fetchJSON<T>(endpoint, {
      ...options,
      body: body ? this.buildBody(body) : undefined,
      method: HttpMethods.PUT
    });
  }

  public patch<T>(endpoint: string, operations, options?: IHttpOptions): Promise<T> {
    return this.fetchJSON<T>(endpoint, {
      parseResponse: false,
      ...options,
      body: JSON.stringify(operations),
      method: HttpMethods.PATCH
    });
  }

  public delete<T>(endpoint: string, options?: IHttpOptions): Promise<T> {
    return this.fetchJSON<T>(endpoint, {
      parseResponse: false,
      ...options,
      method: HttpMethods.DELETE
    });
  }

  private buildBody(body: any): any {
    if (Array.isArray(body)) {
      const bodyObj = Object.assign({}, body);
      return JSON.stringify(bodyObj);
    }
    return JSON.stringify(body);
  }
}

interface IHttpOptions {
  baseURL?: string;
  headers?: any;
  parseResponse?: boolean,
  method: HttpMethods;
  body?: any
}

export enum HttpMethods {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  PATCH = 'PATCH',
  DELETE = 'DELETE'
}
